import '@angular/localize/init';
import * as i0 from '@angular/core';
import { InjectionToken, Component, ChangeDetectionStrategy, Input, Injectable, Inject, signal, Pipe, EventEmitter, Output, Directive, NgModule } from '@angular/core';
import * as i6 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1$1 from '@ngrx/store';
import { createFeatureSelector, createSelector, select, StoreModule } from '@ngrx/store';
import { BehaviorSubject, Subscription, combineLatest, of, Subject } from 'rxjs';
import * as i3$1 from '@fleetmatics/ui.insights';
import * as i1 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import { filter, startWith, map, catchError, take, takeUntil, shareReplay, distinctUntilChanged, withLatestFrom, switchMap } from 'rxjs/operators';
import { SIDE_DRAWER_OUTLET } from '@fleetmatics/ui.base-library/side-drawer';
import * as i3 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from '@angular/material/divider';
import { MatDividerModule } from '@angular/material/divider';
import * as i9 from '@fleetmatics/ui.base-library/button-size';
import { ButtonSizeModule } from '@fleetmatics/ui.base-library/button-size';
import * as i10 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i11 from '@angular/material/legacy-chips';
import { MatLegacyChipsModule } from '@angular/material/legacy-chips';
import * as i12 from '@angular/material/legacy-progress-spinner';
import { MatLegacyProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import * as i2 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import * as moment from 'moment-timezone';
import * as i3$2 from '@angular/cdk/layout';
import * as i1$2 from '@angular/common/http';
import { HttpParams, HttpClientModule } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import * as i1$3 from '@ngrx/effects';
import { createEffect, ofType, EffectsModule } from '@ngrx/effects';
import { ChipTagModule } from '@fleetmatics/ui.base-library/chip-tag';

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
const INSIGHTS_PANEL_CONFIG = new InjectionToken('insightsPanelConfig');

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
const INSIGHT_PANEL_OUTLET = 'insights-panel';

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class EmptyStateComponent {
    constructor() {
        this.title = 'No results';
        this.subtitle = '';
        this.showDefaultIcon = true;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmptyStateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: EmptyStateComponent, selector: "insights-panel-empty-state", inputs: { title: "title", subtitle: "subtitle", iconSvg: "iconSvg", showDefaultIcon: "showDefaultIcon" }, ngImport: i0, template: "<div class=\"empty-state\">\n  <div class=\"empty-state__icon\">\n    <!-- Custom SVG if provided -->\n    <div *ngIf=\"iconSvg\" [innerHTML]=\"iconSvg\"></div>\n\n    <!-- Default SVG icon if no custom SVG provided -->\n    <svg width=\"101\" height=\"65\" viewBox=\"0 0 101 65\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M20 15H99L81 64H2L20 15Z\" fill=\"white\" stroke=\"#6F7171\" stroke-width=\"2\" />\n      <path d=\"M2 64V1H28.5L32.25 5.2H81V12.55\" stroke=\"#6F7171\" stroke-width=\"2\" />\n    </svg>\n  </div>\n\n  <div class=\"empty-state__content\">\n    <h3 class=\"empty-state__title\">{{ title }}</h3>\n    <p class=\"empty-state__subtitle\">{{ subtitle }}</p>\n  </div>\n</div>\n", styles: [".empty-state{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;text-align:center;width:100%;flex:1}.empty-state__icon{margin-bottom:20px;opacity:.6}.empty-state__content{max-width:300px}.empty-state__title{font-size:18px;font-weight:700;color:#000;margin:0 0 4px}.empty-state__subtitle{font-size:14px;font-weight:400;color:#000;margin:0;line-height:1.4}\n"], dependencies: [{ kind: "directive", type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EmptyStateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-empty-state', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"empty-state\">\n  <div class=\"empty-state__icon\">\n    <!-- Custom SVG if provided -->\n    <div *ngIf=\"iconSvg\" [innerHTML]=\"iconSvg\"></div>\n\n    <!-- Default SVG icon if no custom SVG provided -->\n    <svg width=\"101\" height=\"65\" viewBox=\"0 0 101 65\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n      <path d=\"M20 15H99L81 64H2L20 15Z\" fill=\"white\" stroke=\"#6F7171\" stroke-width=\"2\" />\n      <path d=\"M2 64V1H28.5L32.25 5.2H81V12.55\" stroke=\"#6F7171\" stroke-width=\"2\" />\n    </svg>\n  </div>\n\n  <div class=\"empty-state__content\">\n    <h3 class=\"empty-state__title\">{{ title }}</h3>\n    <p class=\"empty-state__subtitle\">{{ subtitle }}</p>\n  </div>\n</div>\n", styles: [".empty-state{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:60px 20px;text-align:center;width:100%;flex:1}.empty-state__icon{margin-bottom:20px;opacity:.6}.empty-state__content{max-width:300px}.empty-state__title{font-size:18px;font-weight:700;color:#000;margin:0 0 4px}.empty-state__subtitle{font-size:14px;font-weight:400;color:#000;margin:0;line-height:1.4}\n"] }]
        }], propDecorators: { title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], iconSvg: [{
                type: Input
            }], showDefaultIcon: [{
                type: Input
            }] } });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
var LoadingState;
(function (LoadingState) {
    LoadingState[LoadingState["_"] = 0] = "_";
    LoadingState[LoadingState["LOADING"] = 1] = "LOADING";
    LoadingState[LoadingState["LOADED"] = 2] = "LOADED";
    LoadingState[LoadingState["ERROR"] = 3] = "ERROR";
})(LoadingState || (LoadingState = {}));

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class LocalStorageService {
    constructor(_document) {
        this._document = _document;
    }
    getItem(key) {
        return this._document.defaultView.localStorage.getItem(key);
    }
    setItem(key, value) {
        this._document.defaultView.localStorage.setItem(key, value);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LocalStorageService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LocalStorageService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LocalStorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
const INSIGHT_PANEL_LOCAL_STORAGE_KEY = 'insight-panel';

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class NavigationService {
    constructor(router, urlSerializer, location, document) {
        this.router = router;
        this.urlSerializer = urlSerializer;
        this.location = location;
        this.document = document;
    }
    /**
     * Utility method to get current query parameters from the URL.
     * @returns Object containing all current query parameters
     */
    getQueryParams() {
        const fullUrl = this.document.defaultView.location.pathname + this.document.defaultView.location.search;
        // Parse it to get all query params
        const tree = this.urlSerializer.parse(fullUrl);
        return tree.queryParams || {};
    }
    /**
     * Generic method to navigate with auxiliary outlet management.
     * Preserves current route and query params while adding/removing the insights panel auxiliary outlet.
     * @param addOutlet - Whether to add (true) or remove (false) the auxiliary outlet
     * @param queryParams - Optional query parameters to update (undefined values will be filtered out)
     */
    navigateWithAuxiliaryOutlet(addOutlet, queryParams) {
        const fullUrl = this.document.defaultView.location.pathname + this.document.defaultView.location.search;
        const tree = this.urlSerializer.parse(fullUrl);
        // Get current query params and merge with provided ones
        const currentQueryParams = tree.queryParams || {};
        const mergedQueryParams = queryParams ? { ...currentQueryParams, ...queryParams } : currentQueryParams;
        // Filter out undefined values
        const filteredParams = {};
        Object.keys(mergedQueryParams).forEach(key => {
            const value = mergedQueryParams[key];
            if (value !== undefined && value !== null) {
                filteredParams[key] = value;
            }
        });
        // Get the current primary route to preserve it - use document location for accuracy
        const currentPath = this.document.defaultView.location.pathname;
        // Extract the application route by removing base path parts (locale, microsite)
        // Server path might be: /en-US/livemap/replay -> we want: /replay
        // Local path might be: /replay -> we want: /replay
        let applicationRoute = currentPath;
        // Common patterns to remove: /en-US/livemap, /en-us/livemap, etc.
        const basePathPatterns = [
            /^\/[a-z]{2}-[A-Z]{2}\/[^/]+/,
            /^\/[a-z]{2}-[a-z]{2}\/[^/]+/, // matches /en-us/livemap
        ];
        for (const pattern of basePathPatterns) {
            if (pattern.test(applicationRoute)) {
                applicationRoute = applicationRoute.replace(pattern, '');
                break;
            }
        }
        // Ensure we have a leading slash and handle empty routes
        if (!applicationRoute.startsWith('/')) {
            applicationRoute = '/' + applicationRoute;
        }
        if (applicationRoute === '/') {
            applicationRoute = '';
        }
        const currentPrimaryRoute = applicationRoute.split('(')[0]; // Extract primary route without auxiliary outlets
        if (addOutlet) {
            // Navigate to current route with auxiliary outlet added
            this.router.navigate([currentPrimaryRoute, { outlets: { [SIDE_DRAWER_OUTLET]: INSIGHT_PANEL_OUTLET } }], {
                queryParams: filteredParams,
                replaceUrl: true,
            });
        }
        else {
            const routeConfig = this.router.routerState?.root?.children.find(childRoute => childRoute.outlet === SIDE_DRAWER_OUTLET && childRoute.snapshot.url.find(u => u.path === INSIGHT_PANEL_OUTLET));
            if (routeConfig ||
                this.router.routerState.snapshot.url.includes(`(${SIDE_DRAWER_OUTLET}:${INSIGHT_PANEL_OUTLET})`) ||
                this.document.location.pathname.includes(`(${SIDE_DRAWER_OUTLET}:${INSIGHT_PANEL_OUTLET})`)) {
                // Navigate to current route with auxiliary outlet removed
                this.router.navigate([currentPrimaryRoute, { outlets: { [SIDE_DRAWER_OUTLET]: null } }], {
                    queryParams: filteredParams,
                    replaceUrl: true,
                });
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NavigationService, deps: [{ token: i1.Router }, { token: i1.UrlSerializer }, { token: i6.Location }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NavigationService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i1.UrlSerializer }, { type: i6.Location }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
var InsightsPanelActionTypes;
(function (InsightsPanelActionTypes) {
    InsightsPanelActionTypes["GetInsightsAction"] = "[InsightsPanel] Get Insights";
    InsightsPanelActionTypes["GetInsightsSuccessAction"] = "[InsightsPanel] Get Insights Success";
    InsightsPanelActionTypes["GetInsightsFailureAction"] = "[InsightsPanel] Get Insights Failure";
    InsightsPanelActionTypes["CheckUserHasMicrositePermissionAction"] = "[InsightsPanel] Check User Has Microsite Permission";
    InsightsPanelActionTypes["CheckUserHasMicrositePermissionSuccessAction"] = "[InsightsPanel] Check User Has Microsite Permission Success";
    InsightsPanelActionTypes["CheckUserHasMicrositePermissionErrorAction"] = "[InsightsPanel] Check User Has Microsite Permission Error";
    InsightsPanelActionTypes["SetUserPreferencesAction"] = "[InsightsPanel] Set User Preferences";
})(InsightsPanelActionTypes || (InsightsPanelActionTypes = {}));
class GetInsights {
    constructor(payload) {
        this.payload = payload;
        this.type = InsightsPanelActionTypes.GetInsightsAction;
    }
}
class GetInsightsSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = InsightsPanelActionTypes.GetInsightsSuccessAction;
    }
}
class GetInsightsFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = InsightsPanelActionTypes.GetInsightsFailureAction;
    }
}
class CheckUserHasMicrositePermission {
    constructor() {
        this.type = InsightsPanelActionTypes.CheckUserHasMicrositePermissionAction;
    }
}
class CheckUserHasMicrositePermissionSuccess {
    constructor(payload) {
        this.payload = payload;
        this.type = InsightsPanelActionTypes.CheckUserHasMicrositePermissionSuccessAction;
    }
}
class CheckUserHasMicrositePermissionFailure {
    constructor(payload) {
        this.payload = payload;
        this.type = InsightsPanelActionTypes.CheckUserHasMicrositePermissionErrorAction;
    }
}
class SetUserPreferences {
    constructor(payload) {
        this.payload = payload;
        this.type = InsightsPanelActionTypes.SetUserPreferencesAction;
    }
}

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
const selectInsightsPanelState = createFeatureSelector('insightsPanel');
const selectHasAccess = createSelector(selectInsightsPanelState, state => state.hasAccess);
const selectDateRange = createSelector(selectInsightsPanelState, state => state.dateRange);
const selectInsightsResponse = createSelector(selectInsightsPanelState, state => ({
    response: state?.response,
    loading: state?.loading,
}));
const selectLoading = createSelector(selectInsightsPanelState, state => state.loading);
const selectError = createSelector(selectInsightsPanelState, state => state.error);
const selectUserPreferences = createSelector(selectInsightsPanelState, state => state.userPreferences);

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
function getWeeklyDateRange() {
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1);
    const fromDate = new Date(today.setDate(diff));
    const toDate = new Date();
    return { fromDate, toDate };
}

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class InsightsPanelService {
    get isPanelOpen() {
        return this._isPanelOpenSignal.asReadonly();
    }
    get drawerMode$() {
        return this._drawerMode$.asObservable();
    }
    constructor(router, store, localStorageService, navigationService, document, config) {
        this.router = router;
        this.store = store;
        this.localStorageService = localStorageService;
        this.navigationService = navigationService;
        this.document = document;
        this.config = config;
        this._drawerMode$ = new BehaviorSubject('over');
        this._canPanelOpen = false;
        this._initialized = false;
        this._closeDrawerCalledBeforeInit = false; // Track close calls before initialization
        this.isResponseLoaded = LoadingState._;
        this._subscriptions = new Subscription();
        this._isPanelOpenSignal = signal(false);
        this.isLoaded = new BehaviorSubject(LoadingState._);
        this.drawerState = new BehaviorSubject(undefined);
    }
    initialize(userPreferences) {
        if (this._initialized) {
            console.error('ERROR: InsightsPanelService is already initialized.');
            return;
        }
        if (!this._userPreferences) {
            this._userPreferences = userPreferences;
        }
        this.checkIfPanelCanBeOpened();
        // If closeDrawer was called before initialization, respect that state
        if (this._closeDrawerCalledBeforeInit) {
            this._canPanelOpen = false;
            this.drawerState.next(false);
        }
        this._subscriptions.add(this.store.select(selectHasAccess).subscribe(hasAccess => {
            if (hasAccess !== undefined) {
                this._canPanelOpen = hasAccess;
                if (!this._canPanelOpen && this.drawerState.value) {
                    this.closeDrawer();
                }
            }
        }));
        this._subscriptions.add(this.store.select(selectInsightsResponse).subscribe(result => {
            this.isResponseLoaded = result.loading;
            if (this.isResponseLoaded !== LoadingState.LOADED && this.isResponseLoaded !== LoadingState.ERROR) {
                return;
            }
            this.response = result.response;
            this.isLoaded.next(this.isResponseLoaded);
        }));
        this._subscriptions.add(combineLatest([this.isLoaded, this.drawerState]).subscribe(([loadingState, drawerState]) => {
            if (loadingState === LoadingState.LOADED && drawerState) {
                this.openDrawer();
            }
            else if (loadingState === LoadingState.ERROR || drawerState === false) {
                this.close();
            }
        }));
        this.observeDrawerOutlet();
        this._initialized = true;
    }
    ngOnDestroy() {
        this._subscriptions.unsubscribe();
        this._drawerOpenTrigger$?.unsubscribe();
    }
    checkIfPanelCanBeOpened() {
        if (!this.config.insightsPanel.enabled) {
            return false;
        }
        const model = JSON.parse(this.localStorageService.getItem(INSIGHT_PANEL_LOCAL_STORAGE_KEY) || '{}');
        this._canPanelOpen = true;
        if (model && model.closeDate) {
            this._canPanelOpen = true;
            const closeDate = new Date(model.closeDate);
            const now = new Date();
            // Get tomorrow's midnight after closeDate
            const closeDateTomorrow = new Date(closeDate);
            closeDateTomorrow.setDate(closeDate.getDate() + 1);
            closeDateTomorrow.setHours(0, 0, 0, 0);
            this._canPanelOpen = now >= closeDateTomorrow;
            if (!this._canPanelOpen) {
                return false;
            }
        }
        const allowedLocale = 'en-us';
        if (this._userPreferences?.language) {
            this._canPanelOpen = this._userPreferences.language.toLocaleLowerCase() === allowedLocale;
            return this._canPanelOpen;
        }
        this._canPanelOpen = this.document.defaultView.location.href.includes(allowedLocale);
        return this._canPanelOpen;
    }
    tryOpenDrawer(force) {
        // Auto-initialize if not already done
        if (!this._initialized) {
            return;
        }
        if (force) {
            this._canPanelOpen = true;
        }
        // Don't open if closeDrawer was called before initialization
        if (!this._canPanelOpen || !this._initialized || this._closeDrawerCalledBeforeInit) {
            return;
        }
        this.store.dispatch(new GetInsights(getWeeklyDateRange()));
        this.drawerState.next(true);
    }
    openDrawer() {
        if (this._isPanelOpenSignal()) {
            return;
        }
        // Use the generic method to add auxiliary outlet and preserve current path
        this.navigationService.navigateWithAuxiliaryOutlet(true);
        this._isPanelOpenSignal.set(true);
    }
    getQueryParams() {
        return this.navigationService.getQueryParams();
    }
    navigateWithAuxiliaryOutlet(addOutlet, queryParams) {
        this.navigationService.navigateWithAuxiliaryOutlet(addOutlet, queryParams);
    }
    closeDrawer() {
        // Track close calls even before initialization
        if (!this._initialized) {
            this._closeDrawerCalledBeforeInit = true;
            return;
        }
        this.drawerState.next(false);
    }
    close() {
        this.navigationService.navigateWithAuxiliaryOutlet(false);
        this._isPanelOpenSignal.set(false);
        this._drawerMode$.next('over');
    }
    /**
     * Reset the close state - useful if you want to allow the drawer to open again
     * after it was closed before initialization
     */
    resetCloseState() {
        this._closeDrawerCalledBeforeInit = false;
    }
    observeDrawerOutlet() {
        let previousOutletPath = null;
        let hasInsightPanelOutlet = false;
        this._subscriptions.add(this.router.events
            .pipe(filter(event => event instanceof NavigationEnd), startWith(null))
            .subscribe(() => {
            const root = this.router.routerState.root;
            let outletRoute = root;
            // Traverse to find the side-drawer outlet
            while (outletRoute) {
                const child = (outletRoute.children ?? []).find(c => c.outlet === SIDE_DRAWER_OUTLET);
                if (child) {
                    outletRoute = child;
                    break;
                }
                outletRoute = outletRoute.firstChild;
            }
            const outletPath = outletRoute?.snapshot.url[0]?.path;
            if (outletPath === INSIGHT_PANEL_OUTLET) {
                this._drawerMode$.next('side');
            }
            if (!hasInsightPanelOutlet && outletPath === INSIGHT_PANEL_OUTLET) {
                hasInsightPanelOutlet = true;
            }
            else if (!outletPath && previousOutletPath && hasInsightPanelOutlet && this.drawerState.value) {
                this.tryOpenDrawer();
            }
            else if (outletPath !== INSIGHT_PANEL_OUTLET) {
                this._drawerMode$.next('over');
            }
            previousOutletPath = outletPath;
        }));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelService, deps: [{ token: i1.Router }, { token: i1$1.Store }, { token: LocalStorageService }, { token: NavigationService }, { token: DOCUMENT }, { token: INSIGHTS_PANEL_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: i1$1.Store }, { type: LocalStorageService }, { type: NavigationService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [INSIGHTS_PANEL_CONFIG]
                }] }]; } });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
function getEncodedTranslatedPageName(key) {
    const translatedName = translatePageName(key);
    return encodeURIComponent(translatedName);
}
function translatePageName(key) {
    switch (key) {
        case 'S_LIVE_MAP': {
            return $localize `:@@S_LIVE_MAP:Live Map`;
        }
        case 'S_REPORTS': {
            return $localize `:@@S_REPORTS:Reports`;
        }
        case 'S_REPLAY': {
            return $localize `:@@S_REPLAY:Replay`;
        }
        case 'S_VIDEO': {
            return $localize `:@@S_VIDEO:Video`;
        }
        case 'S_PLACES': {
            return $localize `:@@S_PLACES:Places`;
        }
        case 'S_ALERTS': {
            return $localize `:@@S_ALERTS:Alerts`;
        }
        case 'S_DASHBOARD': {
            return $localize `:@@S_DASHBOARD:Dashboard`;
        }
        case 'S_SERVICING': {
            return $localize `:@@S_SERVICING:Fleet Service`;
        }
        case 'S_LOGBOOK': {
            return $localize `:@@S_LOGBOOK:Logbook`;
        }
        case 'S_TACHO_MENU_ITEM_TEXT': {
            return $localize `:@@S_TACHO_MENU_ITEM_TEXT:Tacho`;
        }
        case 'S_JOURNEYCLASSIFICATION_BANNER': {
            return $localize `:@@S_JOURNEYCLASSIFICATION_BANNER:Trip Logger`;
        }
        case 'S_INSIGHTS': {
            return $localize `:@@S_INSIGHTS:Insights`;
        }
        default: {
            return '';
        }
    }
}

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class TimezoneService {
    constructor(store) {
        this.store = store;
    }
    /**
     * Converts a UTC datetime to the user's timezone and formats it
     * @param utcDateTime UTC datetime string or Date object
     * @param format Optional format string (defaults to 'MM/DD/YYYY • h:mma')
     * @returns Observable<string> formatted datetime string
     */
    convertToUserTimezone(utcDateTime, format = 'MM/DD/YYYY • h:mma') {
        if (!utcDateTime) {
            return of('');
        }
        return this.store.pipe(select(selectUserPreferences), map((userPreferences) => {
            const timezone = userPreferences?.timezone;
            try {
                const utcDate = utcDateTime instanceof Date ? utcDateTime : new Date(utcDateTime);
                if (isNaN(utcDate.getTime())) {
                    return utcDateTime instanceof Date ? utcDateTime.toString() : utcDateTime.toString();
                }
                // If no timezone is specified, use default formatting
                if (!timezone) {
                    const formatted = moment.utc(utcDateTime).format(format);
                    return format.includes('•') ? formatted.toLowerCase() : formatted;
                }
                const formattedDateTime = moment.utc(utcDateTime).tz(timezone);
                const formatted = formattedDateTime.format(format);
                return format.includes('•') ? formatted.toLowerCase() : formatted;
            }
            catch (error) {
                console.error('Error converting timezone:', error);
                return utcDateTime instanceof Date ? utcDateTime.toString() : utcDateTime.toString();
            }
        }), catchError(() => of(utcDateTime instanceof Date ? utcDateTime.toString() : utcDateTime.toString())));
    }
    /**
     * Synchronously converts a UTC datetime to the user's timezone
     * @param utcDateTime UTC datetime string or Date object
     * @param format Optional format string (defaults to 'MM/DD/YYYY')
     * @param locale Optional locale for fallback formatting
     * @returns string formatted datetime string
     */
    convertToUserTimezoneSync(utcDateTime, format = 'MM/DD/YYYY', locale) {
        if (!utcDateTime) {
            return '';
        }
        let timezone;
        // Get user timezone synchronously from store
        this.store
            .pipe(select(selectUserPreferences), take(1))
            .subscribe(userPreferences => {
            timezone = userPreferences?.timezone;
        })
            .unsubscribe();
        try {
            const utcDate = utcDateTime instanceof Date ? utcDateTime : new Date(utcDateTime);
            if (isNaN(utcDate.getTime())) {
                return utcDateTime instanceof Date ? utcDateTime.toString() : utcDateTime.toString();
            }
            if (timezone) {
                return moment.utc(utcDate).tz(timezone).format(format);
            }
            else {
                // Fallback to locale or moment formatting
                if (locale) {
                    return utcDate.toLocaleDateString(locale);
                }
                else {
                    return moment.utc(utcDate).format(format);
                }
            }
        }
        catch (error) {
            console.error('Error converting timezone in sync method:', error);
            // Fallback to original behavior
            if (locale) {
                return new Date(utcDateTime).toLocaleDateString(locale);
            }
            else {
                return utcDateTime instanceof Date ? utcDateTime.toString() : utcDateTime.toString();
            }
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TimezoneService, deps: [{ token: i1$1.Store }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TimezoneService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TimezoneService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Store }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class PeriodDateFormatterPipe {
    constructor(timezoneService) {
        this.timezoneService = timezoneService;
    }
    transform(fromDate, toDate, locale) {
        if (!fromDate || !toDate) {
            return '';
        }
        const fromFormatted = this.timezoneService.convertToUserTimezoneSync(fromDate, 'MM/DD/YYYY', locale);
        const toFormatted = this.timezoneService.convertToUserTimezoneSync(toDate, 'MM/DD/YYYY', locale);
        return $localize `:@@S_OI_DETAILS_PERIOD:${fromFormatted} to ${toFormatted}`;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeriodDateFormatterPipe, deps: [{ token: TimezoneService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PeriodDateFormatterPipe, name: "periodDateFormatter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PeriodDateFormatterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'periodDateFormatter',
                    pure: true,
                }]
        }], ctorParameters: function () { return [{ type: TimezoneService }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class InsightCardComponent {
    constructor() {
        this.openClicked = new EventEmitter();
    }
    onOpenClicked() {
        this.openClicked.emit(this.insight);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: InsightCardComponent, selector: "insights-panel-insight-card", inputs: { insight: "insight" }, outputs: { openClicked: "openClicked" }, ngImport: i0, template: "<!-- Copyright \u00A9 2025. Verizon Connect Ireland Limited. All rights reserved. -->\n<mat-card class=\"insight-card\" a7s-id=\"insight-card\" (click)=\"onOpenClicked()\">\n  <mat-card-header class=\"insight-card__header\">\n    <mat-card-title class=\"insight-card__header__container\">\n      <div class=\"insight-card__header__container__information\">\n        <div class=\"insight-card__header__container__information__text-container\">\n          <div class=\"insight-card__header__container__information__text-container__tags\">\n            <span class=\"insight-card__container__information__tags__tag\">\n              {{ insight?.categoryName || '' }}\n            </span>\n            <span>\u2022</span>\n            <span class=\"insight-card__container_information__tags__tag\">\n              {{ insight?.subCategoryName || '' }}\n            </span>\n          </div>\n          <div class=\"insight-card__header__container__information__text-container__period\">\n            {{ insight.periodFrom | periodDateFormatter: insight.periodTo }}\n          </div>\n        </div>\n        <span *ngIf=\"!!!insight?.isRead\" class=\"insight-card__header__container__information__notification\"></span>\n      </div>\n      <span class=\"insight-card__header__container__title\">\n        {{ insight?.summary || '' }}\n      </span>\n    </mat-card-title>\n  </mat-card-header>\n  <mat-card-content class=\"insight-card__content\">\n    <div class=\"insight-card__content__preview\" [innerHTML]=\"insight?.bodyPreview\"></div>\n    <mat-icon class=\"insight-card__content__icon\">arrow_forward</mat-icon>\n  </mat-card-content>\n</mat-card>\n", styles: ["@charset \"UTF-8\";.insight-card{border:1px solid #d8dada;border-radius:8px;box-shadow:none}.insight-card:hover{cursor:pointer;background-color:#f2f2f2}.insight-card:active,.insight-card:focus,.insight-card:focus-visible{background-color:#d8dada;border-color:#0000001f}.insight-card:focus-visible{border-color:#000}.insight-card__header{padding:24px 24px 0;gap:8px;justify-content:space-between}.insight-card__header__container{display:flex;flex-direction:column;gap:16px}.insight-card__header__container__title{font-weight:400;font-size:20px;line-height:24px;-webkit-line-clamp:2;line-clamp:2;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;box-shadow:none}.insight-card__header__container__information{display:flex;flex-direction:row;justify-content:space-between;gap:16px}.insight-card__header__container__information__text-container{width:calc(100% - 28px);font-weight:400;font-size:14px;line-height:20px;color:#6f7171;display:flex;flex-direction:column;gap:4px}.insight-card__header__container__information__text-container__tags{font-size:14px;line-height:20px;display:flex;gap:4px}.insight-card__header__container__information__notification{width:12px;height:12px;background:#0089ec;border-radius:50%}.insight-card__content{padding:16px 24px 24px!important;display:flex;flex-direction:row;gap:24px}.insight-card__content__preview{font-size:14px;line-height:20px;color:#6f7171;-webkit-line-clamp:2;line-clamp:2;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.insight-card__content__icon{align-self:end}\n"], dependencies: [{ kind: "directive", type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatCard, selector: "mat-card", inputs: ["appearance"], exportAs: ["matCard"] }, { kind: "directive", type: i2.MatCardContent, selector: "mat-card-content" }, { kind: "component", type: i2.MatCardHeader, selector: "mat-card-header" }, { kind: "directive", type: i2.MatCardTitle, selector: "mat-card-title, [mat-card-title], [matCardTitle]" }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "pipe", type: PeriodDateFormatterPipe, name: "periodDateFormatter" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-insight-card', template: "<!-- Copyright \u00A9 2025. Verizon Connect Ireland Limited. All rights reserved. -->\n<mat-card class=\"insight-card\" a7s-id=\"insight-card\" (click)=\"onOpenClicked()\">\n  <mat-card-header class=\"insight-card__header\">\n    <mat-card-title class=\"insight-card__header__container\">\n      <div class=\"insight-card__header__container__information\">\n        <div class=\"insight-card__header__container__information__text-container\">\n          <div class=\"insight-card__header__container__information__text-container__tags\">\n            <span class=\"insight-card__container__information__tags__tag\">\n              {{ insight?.categoryName || '' }}\n            </span>\n            <span>\u2022</span>\n            <span class=\"insight-card__container_information__tags__tag\">\n              {{ insight?.subCategoryName || '' }}\n            </span>\n          </div>\n          <div class=\"insight-card__header__container__information__text-container__period\">\n            {{ insight.periodFrom | periodDateFormatter: insight.periodTo }}\n          </div>\n        </div>\n        <span *ngIf=\"!!!insight?.isRead\" class=\"insight-card__header__container__information__notification\"></span>\n      </div>\n      <span class=\"insight-card__header__container__title\">\n        {{ insight?.summary || '' }}\n      </span>\n    </mat-card-title>\n  </mat-card-header>\n  <mat-card-content class=\"insight-card__content\">\n    <div class=\"insight-card__content__preview\" [innerHTML]=\"insight?.bodyPreview\"></div>\n    <mat-icon class=\"insight-card__content__icon\">arrow_forward</mat-icon>\n  </mat-card-content>\n</mat-card>\n", styles: ["@charset \"UTF-8\";.insight-card{border:1px solid #d8dada;border-radius:8px;box-shadow:none}.insight-card:hover{cursor:pointer;background-color:#f2f2f2}.insight-card:active,.insight-card:focus,.insight-card:focus-visible{background-color:#d8dada;border-color:#0000001f}.insight-card:focus-visible{border-color:#000}.insight-card__header{padding:24px 24px 0;gap:8px;justify-content:space-between}.insight-card__header__container{display:flex;flex-direction:column;gap:16px}.insight-card__header__container__title{font-weight:400;font-size:20px;line-height:24px;-webkit-line-clamp:2;line-clamp:2;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;box-shadow:none}.insight-card__header__container__information{display:flex;flex-direction:row;justify-content:space-between;gap:16px}.insight-card__header__container__information__text-container{width:calc(100% - 28px);font-weight:400;font-size:14px;line-height:20px;color:#6f7171;display:flex;flex-direction:column;gap:4px}.insight-card__header__container__information__text-container__tags{font-size:14px;line-height:20px;display:flex;gap:4px}.insight-card__header__container__information__notification{width:12px;height:12px;background:#0089ec;border-radius:50%}.insight-card__content{padding:16px 24px 24px!important;display:flex;flex-direction:row;gap:24px}.insight-card__content__preview{font-size:14px;line-height:20px;color:#6f7171;-webkit-line-clamp:2;line-clamp:2;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden}.insight-card__content__icon{align-self:end}\n"] }]
        }], propDecorators: { insight: [{
                type: Input
            }], openClicked: [{
                type: Output
            }] } });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class ThumbUpComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbUpComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ThumbUpComponent, selector: "insights-panel-thumb-up", ngImport: i0, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.83464 9.1665L9.16797 1.6665C9.83101 1.6665 10.4669 1.9299 10.9357 2.39874C11.4046 2.86758 11.668 3.50346 11.668 4.1665V7.49984H16.3846C16.6262 7.4971 16.8655 7.54692 17.0859 7.64585C17.3064 7.74478 17.5026 7.89045 17.6612 8.07277C17.8197 8.25508 17.9367 8.46969 18.0041 8.70171C18.0714 8.93374 18.0876 9.17763 18.0513 9.4165L16.9013 16.9165C16.841 17.3139 16.6392 17.6762 16.3329 17.9365C16.0266 18.1968 15.6366 18.3377 15.2346 18.3332H5.83464M5.83464 9.1665V18.3332M5.83464 9.1665H3.33464C2.89261 9.1665 2.46868 9.3421 2.15612 9.65466C1.84356 9.96722 1.66797 10.3911 1.66797 10.8332V16.6665C1.66797 17.1085 1.84356 17.5325 2.15612 17.845C2.46868 18.1576 2.89261 18.3332 3.33464 18.3332H5.83464\" stroke=\"#1E1E1E\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbUpComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-thumb-up', changeDetection: ChangeDetectionStrategy.OnPush, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M5.83464 9.1665L9.16797 1.6665C9.83101 1.6665 10.4669 1.9299 10.9357 2.39874C11.4046 2.86758 11.668 3.50346 11.668 4.1665V7.49984H16.3846C16.6262 7.4971 16.8655 7.54692 17.0859 7.64585C17.3064 7.74478 17.5026 7.89045 17.6612 8.07277C17.8197 8.25508 17.9367 8.46969 18.0041 8.70171C18.0714 8.93374 18.0876 9.17763 18.0513 9.4165L16.9013 16.9165C16.841 17.3139 16.6392 17.6762 16.3329 17.9365C16.0266 18.1968 15.6366 18.3377 15.2346 18.3332H5.83464M5.83464 9.1665V18.3332M5.83464 9.1665H3.33464C2.89261 9.1665 2.46868 9.3421 2.15612 9.65466C1.84356 9.96722 1.66797 10.3911 1.66797 10.8332V16.6665C1.66797 17.1085 1.84356 17.5325 2.15612 17.845C2.46868 18.1576 2.89261 18.3332 3.33464 18.3332H5.83464\" stroke=\"#1E1E1E\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n" }]
        }] });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class ThumbUpSelectedComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbUpSelectedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ThumbUpSelectedComponent, selector: "insights-panel-thumb-up-selected", ngImport: i0, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M11.668 7.49984V4.1665C11.668 3.50346 11.4046 2.86758 10.9357 2.39874C10.4669 1.9299 9.83101 1.6665 9.16797 1.6665L5.83464 9.1665V18.3332H15.2346C15.6366 18.3377 16.0266 18.1968 16.3329 17.9365C16.6392 17.6762 16.841 17.3139 16.9013 16.9165L18.0513 9.4165C18.0876 9.17763 18.0714 8.93374 18.0041 8.70171C17.9367 8.46969 17.8197 8.25508 17.6612 8.07277C17.5026 7.89045 17.3064 7.74478 17.0859 7.64585C16.8655 7.54692 16.6262 7.4971 16.3846 7.49984H11.668ZM5.83464 18.3332H3.33464C2.89261 18.3332 2.46868 18.1576 2.15612 17.845C1.84356 17.5325 1.66797 17.1085 1.66797 16.6665V10.8332C1.66797 10.3911 1.84356 9.96722 2.15612 9.65466C2.46868 9.3421 2.89261 9.1665 3.33464 9.1665H5.83464\" fill=\"black\"/>\n<path d=\"M5.83464 9.1665L9.16797 1.6665C9.83101 1.6665 10.4669 1.9299 10.9357 2.39874C11.4046 2.86758 11.668 3.50346 11.668 4.1665V7.49984H16.3846C16.6262 7.4971 16.8655 7.54692 17.0859 7.64585C17.3064 7.74478 17.5026 7.89045 17.6612 8.07277C17.8197 8.25508 17.9367 8.46969 18.0041 8.70171C18.0714 8.93374 18.0876 9.17763 18.0513 9.4165L16.9013 16.9165C16.841 17.3139 16.6392 17.6762 16.3329 17.9365C16.0266 18.1968 15.6366 18.3377 15.2346 18.3332H5.83464M5.83464 9.1665V18.3332M5.83464 9.1665H3.33464C2.89261 9.1665 2.46868 9.3421 2.15612 9.65466C1.84356 9.96722 1.66797 10.3911 1.66797 10.8332V16.6665C1.66797 17.1085 1.84356 17.5325 2.15612 17.845C2.46868 18.1576 2.89261 18.3332 3.33464 18.3332H5.83464\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M5.83464 18.3332H3.33464C2.89261 18.3332 2.46868 18.1576 2.15612 17.845C1.84356 17.5325 1.66797 17.1085 1.66797 16.6665V10.8332C1.66797 10.3911 1.84356 9.96722 2.15612 9.65466C2.46868 9.3421 2.89261 9.1665 3.33464 9.1665H5.83464\" fill=\"white\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbUpSelectedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-thumb-up-selected', changeDetection: ChangeDetectionStrategy.OnPush, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M11.668 7.49984V4.1665C11.668 3.50346 11.4046 2.86758 10.9357 2.39874C10.4669 1.9299 9.83101 1.6665 9.16797 1.6665L5.83464 9.1665V18.3332H15.2346C15.6366 18.3377 16.0266 18.1968 16.3329 17.9365C16.6392 17.6762 16.841 17.3139 16.9013 16.9165L18.0513 9.4165C18.0876 9.17763 18.0714 8.93374 18.0041 8.70171C17.9367 8.46969 17.8197 8.25508 17.6612 8.07277C17.5026 7.89045 17.3064 7.74478 17.0859 7.64585C16.8655 7.54692 16.6262 7.4971 16.3846 7.49984H11.668ZM5.83464 18.3332H3.33464C2.89261 18.3332 2.46868 18.1576 2.15612 17.845C1.84356 17.5325 1.66797 17.1085 1.66797 16.6665V10.8332C1.66797 10.3911 1.84356 9.96722 2.15612 9.65466C2.46868 9.3421 2.89261 9.1665 3.33464 9.1665H5.83464\" fill=\"black\"/>\n<path d=\"M5.83464 9.1665L9.16797 1.6665C9.83101 1.6665 10.4669 1.9299 10.9357 2.39874C11.4046 2.86758 11.668 3.50346 11.668 4.1665V7.49984H16.3846C16.6262 7.4971 16.8655 7.54692 17.0859 7.64585C17.3064 7.74478 17.5026 7.89045 17.6612 8.07277C17.8197 8.25508 17.9367 8.46969 18.0041 8.70171C18.0714 8.93374 18.0876 9.17763 18.0513 9.4165L16.9013 16.9165C16.841 17.3139 16.6392 17.6762 16.3329 17.9365C16.0266 18.1968 15.6366 18.3377 15.2346 18.3332H5.83464M5.83464 9.1665V18.3332M5.83464 9.1665H3.33464C2.89261 9.1665 2.46868 9.3421 2.15612 9.65466C1.84356 9.96722 1.66797 10.3911 1.66797 10.8332V16.6665C1.66797 17.1085 1.84356 17.5325 2.15612 17.845C2.46868 18.1576 2.89261 18.3332 3.33464 18.3332H5.83464\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M5.83464 18.3332H3.33464C2.89261 18.3332 2.46868 18.1576 2.15612 17.845C1.84356 17.5325 1.66797 17.1085 1.66797 16.6665V10.8332C1.66797 10.3911 1.84356 9.96722 2.15612 9.65466C2.46868 9.3421 2.89261 9.1665 3.33464 9.1665H5.83464\" fill=\"white\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n" }]
        }] });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class ThumbDownComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbDownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ThumbDownComponent, selector: "insights-panel-thumb-down", ngImport: i0, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M14.1654 10.8335L10.832 18.3335C10.169 18.3335 9.53311 18.0701 9.06426 17.6013C8.59542 17.1324 8.33203 16.4965 8.33203 15.8335V12.5002H3.61537C3.37378 12.5029 3.13448 12.4531 2.91406 12.3541C2.69363 12.2552 2.49735 12.1096 2.33882 11.9272C2.18028 11.7449 2.06328 11.5303 1.99591 11.2983C1.92855 11.0663 1.91244 10.8224 1.9487 10.5835L3.0987 3.0835C3.15897 2.68608 3.36084 2.32382 3.66711 2.06349C3.97338 1.80316 4.36342 1.66229 4.76536 1.66683H14.1654M14.1654 10.8335V1.66683M14.1654 10.8335H16.6654C17.1074 10.8335 17.5313 10.6579 17.8439 10.3453C18.1564 10.0328 18.332 9.60886 18.332 9.16683V3.3335C18.332 2.89147 18.1564 2.46755 17.8439 2.15499C17.5313 1.84242 17.1074 1.66683 16.6654 1.66683H14.1654\" stroke=\"#1E1E1E\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbDownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-thumb-down', changeDetection: ChangeDetectionStrategy.OnPush, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M14.1654 10.8335L10.832 18.3335C10.169 18.3335 9.53311 18.0701 9.06426 17.6013C8.59542 17.1324 8.33203 16.4965 8.33203 15.8335V12.5002H3.61537C3.37378 12.5029 3.13448 12.4531 2.91406 12.3541C2.69363 12.2552 2.49735 12.1096 2.33882 11.9272C2.18028 11.7449 2.06328 11.5303 1.99591 11.2983C1.92855 11.0663 1.91244 10.8224 1.9487 10.5835L3.0987 3.0835C3.15897 2.68608 3.36084 2.32382 3.66711 2.06349C3.97338 1.80316 4.36342 1.66229 4.76536 1.66683H14.1654M14.1654 10.8335V1.66683M14.1654 10.8335H16.6654C17.1074 10.8335 17.5313 10.6579 17.8439 10.3453C18.1564 10.0328 18.332 9.60886 18.332 9.16683V3.3335C18.332 2.89147 18.1564 2.46755 17.8439 2.15499C17.5313 1.84242 17.1074 1.66683 16.6654 1.66683H14.1654\" stroke=\"#1E1E1E\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n" }]
        }] });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class ThumbDownSelectedComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbDownSelectedComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: ThumbDownSelectedComponent, selector: "insights-panel-thumb-down-selected", ngImport: i0, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.33203 12.5002V15.8335C8.33203 16.4965 8.59542 17.1324 9.06426 17.6013C9.53311 18.0701 10.169 18.3335 10.832 18.3335L14.1654 10.8335V1.66683H4.76536C4.36342 1.66229 3.97338 1.80316 3.66711 2.06349C3.36084 2.32382 3.15897 2.68608 3.0987 3.0835L1.9487 10.5835C1.91244 10.8224 1.92855 11.0663 1.99591 11.2983C2.06328 11.5303 2.18028 11.7449 2.33882 11.9272C2.49735 12.1096 2.69363 12.2552 2.91405 12.3541C3.13448 12.4531 3.37378 12.5029 3.61537 12.5002H8.33203ZM14.1654 1.66683H16.6654C17.1074 1.66683 17.5313 1.84242 17.8439 2.15499C18.1564 2.46755 18.332 2.89147 18.332 3.3335V9.16683C18.332 9.60886 18.1564 10.0328 17.8439 10.3453C17.5313 10.6579 17.1074 10.8335 16.6654 10.8335H14.1654\" fill=\"black\"/>\n<path d=\"M14.1654 10.8335L10.832 18.3335C10.169 18.3335 9.53311 18.0701 9.06426 17.6013C8.59542 17.1324 8.33203 16.4965 8.33203 15.8335V12.5002H3.61537C3.37378 12.5029 3.13448 12.4531 2.91405 12.3541C2.69363 12.2552 2.49735 12.1096 2.33882 11.9272C2.18028 11.7449 2.06328 11.5303 1.99591 11.2983C1.92855 11.0663 1.91244 10.8224 1.9487 10.5835L3.0987 3.0835C3.15897 2.68608 3.36084 2.32382 3.66711 2.06349C3.97338 1.80316 4.36342 1.66229 4.76536 1.66683H14.1654M14.1654 10.8335V1.66683M14.1654 10.8335H16.6654C17.1074 10.8335 17.5313 10.6579 17.8439 10.3453C18.1564 10.0328 18.332 9.60886 18.332 9.16683V3.3335C18.332 2.89147 18.1564 2.46755 17.8439 2.15499C17.5313 1.84242 17.1074 1.66683 16.6654 1.66683H14.1654\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M14.1654 1.66683H16.6654C17.1074 1.66683 17.5313 1.84242 17.8439 2.15499C18.1564 2.46755 18.332 2.89147 18.332 3.3335V9.16683C18.332 9.60886 18.1564 10.0328 17.8439 10.3453C17.5313 10.6579 17.1074 10.8335 16.6654 10.8335H14.1654\" fill=\"white\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ThumbDownSelectedComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-thumb-down-selected', changeDetection: ChangeDetectionStrategy.OnPush, template: "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.33203 12.5002V15.8335C8.33203 16.4965 8.59542 17.1324 9.06426 17.6013C9.53311 18.0701 10.169 18.3335 10.832 18.3335L14.1654 10.8335V1.66683H4.76536C4.36342 1.66229 3.97338 1.80316 3.66711 2.06349C3.36084 2.32382 3.15897 2.68608 3.0987 3.0835L1.9487 10.5835C1.91244 10.8224 1.92855 11.0663 1.99591 11.2983C2.06328 11.5303 2.18028 11.7449 2.33882 11.9272C2.49735 12.1096 2.69363 12.2552 2.91405 12.3541C3.13448 12.4531 3.37378 12.5029 3.61537 12.5002H8.33203ZM14.1654 1.66683H16.6654C17.1074 1.66683 17.5313 1.84242 17.8439 2.15499C18.1564 2.46755 18.332 2.89147 18.332 3.3335V9.16683C18.332 9.60886 18.1564 10.0328 17.8439 10.3453C17.5313 10.6579 17.1074 10.8335 16.6654 10.8335H14.1654\" fill=\"black\"/>\n<path d=\"M14.1654 10.8335L10.832 18.3335C10.169 18.3335 9.53311 18.0701 9.06426 17.6013C8.59542 17.1324 8.33203 16.4965 8.33203 15.8335V12.5002H3.61537C3.37378 12.5029 3.13448 12.4531 2.91405 12.3541C2.69363 12.2552 2.49735 12.1096 2.33882 11.9272C2.18028 11.7449 2.06328 11.5303 1.99591 11.2983C1.92855 11.0663 1.91244 10.8224 1.9487 10.5835L3.0987 3.0835C3.15897 2.68608 3.36084 2.32382 3.66711 2.06349C3.97338 1.80316 4.36342 1.66229 4.76536 1.66683H14.1654M14.1654 10.8335V1.66683M14.1654 10.8335H16.6654C17.1074 10.8335 17.5313 10.6579 17.8439 10.3453C18.1564 10.0328 18.332 9.60886 18.332 9.16683V3.3335C18.332 2.89147 18.1564 2.46755 17.8439 2.15499C17.5313 1.84242 17.1074 1.66683 16.6654 1.66683H14.1654\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M14.1654 1.66683H16.6654C17.1074 1.66683 17.5313 1.84242 17.8439 2.15499C18.1564 2.46755 18.332 2.89147 18.332 3.3335V9.16683C18.332 9.60886 18.1564 10.0328 17.8439 10.3453C17.5313 10.6579 17.1074 10.8335 16.6654 10.8335H14.1654\" fill=\"white\" stroke=\"black\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>\n" }]
        }] });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class LearnMoreCardComponent {
    constructor() {
        this.learnMoreClicked = new EventEmitter();
    }
    onLearnMoreClicked() {
        this.learnMoreClicked.emit();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LearnMoreCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: LearnMoreCardComponent, selector: "insights-panel-learn-more-card", outputs: { learnMoreClicked: "learnMoreClicked" }, ngImport: i0, template: "<div class=\"container\">\n  <mat-icon class=\"container__information-icon\"> information </mat-icon>\n  <div class=\"container__content\">\n    <span class=\"container__content__text\"> Insights are now available to help you optimize your fleet\u2019s performance. </span>\n    <span class=\"container__content__learn-more\" (click)=\"onLearnMoreClicked()\" a7s-id=\"insight-card-learnmore\">Learn more</span>\n  </div>\n</div>\n", styles: [".container{background-color:#e3f2fd;border-radius:4px;gap:8px;padding:12px;display:flex;flex-wrap:nowrap}.container__information-icon{width:14px;height:14px;flex:none;order:0;flex-grow:0;align-self:flex-start;font-size:14px;color:#006fc1;padding-top:3px}.container__content{display:flex;flex-direction:column}.container__content__learn-more{text-decoration:underline}.container__content__learn-more:hover{cursor:pointer;color:#00517b}.container__content__learn-more:active{color:#74b0ff}\n"], dependencies: [{ kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LearnMoreCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'insights-panel-learn-more-card', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"container\">\n  <mat-icon class=\"container__information-icon\"> information </mat-icon>\n  <div class=\"container__content\">\n    <span class=\"container__content__text\"> Insights are now available to help you optimize your fleet\u2019s performance. </span>\n    <span class=\"container__content__learn-more\" (click)=\"onLearnMoreClicked()\" a7s-id=\"insight-card-learnmore\">Learn more</span>\n  </div>\n</div>\n", styles: [".container{background-color:#e3f2fd;border-radius:4px;gap:8px;padding:12px;display:flex;flex-wrap:nowrap}.container__information-icon{width:14px;height:14px;flex:none;order:0;flex-grow:0;align-self:flex-start;font-size:14px;color:#006fc1;padding-top:3px}.container__content{display:flex;flex-direction:column}.container__content__learn-more{text-decoration:underline}.container__content__learn-more:hover{cursor:pointer;color:#00517b}.container__content__learn-more:active{color:#74b0ff}\n"] }]
        }], propDecorators: { learnMoreClicked: [{
                type: Output
            }] } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class InsightsPanelComponent {
    constructor(store, config, localStorageService, pendoService, document, navigationService, insightsPanelService, changeDetectionRef) {
        this.store = store;
        this.config = config;
        this.localStorageService = localStorageService;
        this.pendoService = pendoService;
        this.document = document;
        this.navigationService = navigationService;
        this.insightsPanelService = insightsPanelService;
        this.changeDetectionRef = changeDetectionRef;
        this.panelClosed = new EventEmitter();
        // locale: string;
        this.pageName = '';
        this.loading = false;
        this.isPositiveFeedback = false;
        this.isNegativeFeedback = false;
        this.subscription = new Subscription();
    }
    ngOnInit() {
        this.pageName = getEncodedTranslatedPageName(this.config.insightsPanel.pageNameKey);
        this.setLearnMoreVisible();
        this.subscription.add(combineLatest([this.store.select(selectDateRange), this.store.select(selectUserPreferences)]).subscribe(([dateRange, userPreferences]) => {
            if (!dateRange || !dateRange.fromDate || !dateRange.toDate || !userPreferences || !userPreferences.language) {
                return;
            }
            this.dateRange = dateRange;
            const options = { month: 'long', day: 'numeric', year: 'numeric' };
            const formatted = dateRange.fromDate.toLocaleDateString(userPreferences.language, options).toUpperCase();
            this.dateTitle = $localize `:@@S_WEEK_OF:WEEK OF ${formatted}:INTERPOLATION:`;
        }));
        this.subscription.add(this.store.select(selectInsightsResponse).subscribe(result => {
            this.loading = result?.loading === LoadingState.LOADING;
            if (!result?.response) {
                return;
            }
            this.insightsResponse = result.response;
            this.changeDetectionRef.markForCheck();
        }));
        if (!this.insightsResponse) {
            const currentParams = this.navigationService.getQueryParams();
            this.navigationService.navigateWithAuxiliaryOutlet(false, { ...currentParams });
        }
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
    getContentState() {
        if (this.loading) {
            return 'loading';
        }
        if (this.insightsResponse?.results.length > 0) {
            return 'hasResults';
        }
        return 'empty';
    }
    onInsightClicked(insight) {
        const pendoInfo = {
            dateRangeStart: this.dateRange?.fromDate?.toUTCString(),
            dateRangeEnd: this.dateRange?.toDate?.toUTCString(),
            dateUTC: new Date().toUTCString(),
            insightId: insight.insightId,
            category: insight.categoryName,
            subcategory: insight.subCategoryName,
            summary: insight.summary,
            periodFrom: insight.periodFrom,
            periodTo: insight.periodTo,
            pageName: this.pageName,
        };
        this.pendoService.trackEvent('irhp_insight_clicked', pendoInfo);
        const url = `${this.config.insightsPanel.insightsMicrosite}/insight/${insight.insightId}?pageName=${this.pageName}`;
        if (url && this.document.defaultView) {
            this.document.defaultView.location.assign(url);
        }
    }
    onCloseClicked() {
        const pendoInfo = {
            dateRangeStart: this.dateRange?.fromDate?.toUTCString(),
            dateRangeEnd: this.dateRange?.toDate?.toUTCString(),
            dateUTC: new Date().toUTCString(),
            pageName: this.pageName,
        };
        this.pendoService.trackEvent('irhp_closed', pendoInfo);
        let model = JSON.parse(this.localStorageService.getItem(INSIGHT_PANEL_LOCAL_STORAGE_KEY) || '{}');
        if (!model) {
            model = { closeDate: new Date().toDateString() };
        }
        else {
            model.closeDate = new Date().toDateString();
        }
        this.localStorageService.setItem(INSIGHT_PANEL_LOCAL_STORAGE_KEY, JSON.stringify(model));
        this.insightsPanelService.closeDrawer();
        this.panelClosed.emit();
    }
    openInsights() {
        const pendoInfo = {
            dateUTC: new Date().toUTCString(),
            pageName: this.pageName,
        };
        this.pendoService.trackEvent('irhp_open_insights_clicked', pendoInfo);
        const url = `${this.config.insightsPanel.insightsMicrosite}/latest`;
        if (url && this.document.defaultView) {
            this.document.defaultView.location.assign(url);
        }
    }
    feedback(isPositive = false) {
        const feedbackInfo = {
            dateRangeStart: this.dateRange?.fromDate?.toUTCString(),
            dateRangeEnd: this.dateRange?.toDate?.toUTCString(),
            dateUTC: new Date().toUTCString(),
        };
        if (isPositive) {
            this.isPositiveFeedback = !this.isPositiveFeedback;
            this.isNegativeFeedback = false;
        }
        else {
            this.isNegativeFeedback = !this.isNegativeFeedback;
            this.isPositiveFeedback = false;
        }
        const eventName = isPositive ? 'irhp_thumb_up_clicked' : 'irhp_thumb_down_clicked';
        this.pendoService.trackEvent(eventName, feedbackInfo);
    }
    onLearnMoreClicked() {
        const pendoInfo = {
            dateUTC: new Date().toUTCString(),
            pageName: this.pageName,
        };
        this.pendoService.trackEvent('irhp_learn_more_clicked', pendoInfo);
        const url = `${this.config.insightsPanel.insightsMicrosite}/learn-more`;
        if (url && this.document.defaultView) {
            this.document.defaultView.open(url, '_blank');
        }
    }
    setLearnMoreVisible() {
        if (this.learnMoreVisible !== undefined) {
            return;
        }
        let model = JSON.parse(this.localStorageService.getItem(INSIGHT_PANEL_LOCAL_STORAGE_KEY) || '{}');
        if (!model) {
            this.learnMoreVisible = true;
            model = { visibilityDate: new Date().toDateString() };
            this.localStorageService.setItem(INSIGHT_PANEL_LOCAL_STORAGE_KEY, JSON.stringify(model));
        }
        if (model.visibilityDate) {
            const visibilityDate = new Date(model.visibilityDate);
            const now = new Date();
            const diffInMs = now.getTime() - visibilityDate.getTime();
            const oneDayInMS = 1000 * 60 * 60 * 24;
            const diffInDays = diffInMs / oneDayInMS;
            this.learnMoreVisible = diffInDays <= 7;
        }
        else {
            this.learnMoreVisible = true;
            model.visibilityDate = new Date().toDateString();
            this.localStorageService.setItem(INSIGHT_PANEL_LOCAL_STORAGE_KEY, JSON.stringify(model));
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelComponent, deps: [{ token: i1$1.Store }, { token: INSIGHTS_PANEL_CONFIG }, { token: LocalStorageService }, { token: i3$1.PendoService }, { token: DOCUMENT }, { token: NavigationService }, { token: InsightsPanelService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: InsightsPanelComponent, selector: "insights-panel", outputs: { panelClosed: "panelClosed" }, providers: [], ngImport: i0, template: "<div class=\"insights-panel\">\n  <div class=\"insights-panel__header\">\n    <div class=\"insights-panel__header__content\">\n      <span class=\"insights-panel__header__content__date\">{{ dateTitle }}</span>\n      <span class=\"insights-panel__header__content__title\">Insight highlights</span>\n    </div>\n    <div class=\"insights-panel__header__actions\">\n      <button\n        mat-icon-button\n        class=\"insights-panel__header__actions__close\"\n        tabindex=\"-1\"\n        vzcButtonSize=\"small\"\n        (click)=\"onCloseClicked()\"\n        data-automation-id=\"insights-panel_close-button\"\n        a7s-id=\"insights-panel_close-button\"\n      >\n        <mat-icon vzcIconSize=\"extraSmall\" svgIcon=\"ds-ic-close\"></mat-icon>\n      </button>\n    </div>\n  </div>\n\n  <mat-divider></mat-divider>\n\n  <div class=\"insights-panel__content\" [ngSwitch]=\"getContentState()\">\n    <div *ngSwitchCase=\"'loading'\" class=\"insights-panel__content__loading-state\">\n      <mat-spinner [diameter]=\"28\" color=\"accent\"></mat-spinner>\n    </div>\n\n    <ng-container *ngSwitchCase=\"'hasResults'\">\n      <insights-panel-learn-more-card *ngIf=\"learnMoreVisible\" (learnMoreClicked)=\"onLearnMoreClicked()\"></insights-panel-learn-more-card>\n\n      <insights-panel-insight-card\n        *ngFor=\"let insight of insightsResponse.results\"\n        [insight]=\"insight\"\n        (openClicked)=\"onInsightClicked($event)\"\n      ></insights-panel-insight-card>\n\n      <div class=\"insights-panel__content__feedback\">\n        <span class=\"insights-panel__content__feedback__text\"> Is this panel useful? </span>\n\n        <mat-chip-list class=\"insights-panel__content__feedback__chips\">\n          <mat-chip class=\"insights-panel__content__feedback__chips__chip\" a7s-id=\"insights-feedback-positive\" (click)=\"feedback(true)\">\n            <insights-panel-thumb-up class=\"icon\" *ngIf=\"!isPositiveFeedback\"></insights-panel-thumb-up>\n            <insights-panel-thumb-up-selected class=\"icon\" *ngIf=\"isPositiveFeedback\"></insights-panel-thumb-up-selected>\n          </mat-chip>\n          <mat-chip class=\"insights-panel__content__feedback__chips__chip\" a7s-id=\"insights-feedback-negative\" (click)=\"feedback(false)\">\n            <insights-panel-thumb-down class=\"icon\" *ngIf=\"!isNegativeFeedback\"></insights-panel-thumb-down>\n            <insights-panel-thumb-down-selected class=\"icon\" *ngIf=\"isNegativeFeedback\"></insights-panel-thumb-down-selected>\n          </mat-chip>\n        </mat-chip-list>\n      </div>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <insights-panel-learn-more-card *ngIf=\"learnMoreVisible\" (learnMoreClicked)=\"onLearnMoreClicked()\"></insights-panel-learn-more-card>\n      <insights-panel-empty-state title=\"No results\"></insights-panel-empty-state>\n    </ng-container>\n  </div>\n\n  <div class=\"insights-panel__footer\">\n    <div class=\"insights-panel__footer__actions\">\n      <button\n        class=\"insights-panel__footer__actions__button\"\n        mat-flat-button\n        color=\"accent\"\n        (click)=\"openInsights()\"\n        data-automation-id=\"insights-panel_open-insights-button\"\n        a7s-id=\"insights-panel_open-insights-button\"\n      >\n        GO TO INSIGHTS\n      </button>\n    </div>\n\n    <div class=\"insights-panel__footer__content\">\n      <span class=\"insights-panel__footer__content__text\">\n        This feature is an AI Beta release. Results may contain bugs, errors, or inaccuracies.\n      </span>\n    </div>\n  </div>\n</div>\n", styles: ["@charset \"UTF-8\";@import\"https://fonts.googleapis.com/icon?family=Material+Icons\";mat-icon{width:16px;height:16px;display:inline-flex!important;flex-shrink:0;justify-content:center}.pointer:hover{cursor:pointer;color:gray}h3{display:block;font-size:1.17em;font-weight:700!important}h4{font-size:.875rem;display:block;font-weight:700!important}.zendesk-link{cursor:pointer;color:#0088ce!important;text-decoration:none}.zendesk-link:hover{color:#005e8f!important;text-decoration:underline!important}.insights-panel{display:flex;flex-direction:column;height:100%}.insights-panel__header{flex-shrink:0;width:100%;border-bottom:1px solid #e0e0e0;padding:20px 24px 19px;display:flex;align-items:center;justify-content:space-between;z-index:10}.insights-panel__header__content{display:flex;flex-direction:column;gap:3px}.insights-panel__header__content__date{line-height:18px;font-size:12px;font-weight:400;color:#6f7171}.insights-panel__header__content__title{font-size:16px;font-weight:700;line-height:22px}.insights-panel__header__actions{margin-top:-24px}.insights-panel__content{flex:1 1 auto;overflow:auto;padding:16px;gap:16px;display:flex;flex-direction:column}.insights-panel__content__loading-state{display:flex;align-items:center;justify-content:center;gap:12px;padding:16px;color:#6f7171}.insights-panel__content__feedback{display:flex;flex-direction:row;justify-content:space-between;border-radius:38px;background:#f6f6f6;align-items:center;padding:0 16px;white-space:nowrap}.insights-panel__content__feedback__text{font-size:12px;line-height:18px;font-weight:400;vertical-align:middle}.insights-panel__content__feedback__chips{height:36px;padding-top:8px;margin-bottom:4px}.insights-panel__content__feedback__chips__chip{min-height:24px;background:transparent;color:transparent;padding:7px}.insights-panel__content__feedback__chips__chip .icon{height:20px}.insights-panel__content__feedback__chips__chip:hover{cursor:pointer}.insights-panel__footer{flex-shrink:0;width:100%;position:sticky;bottom:0;z-index:10}.insights-panel__footer__content{padding:0 16px 24px;display:flex;text-align:center;font-size:12px;flex-direction:column}.insights-panel__footer__content__text{color:#6f7171}.insights-panel__footer__content__link{text-decoration:underline}.insights-panel__footer__actions{padding:16px;border-top:1px solid #d8dada}.insights-panel__footer__actions__button{width:100%;font-weight:700}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary{background-color:transparent;color:transparent}\n"], dependencies: [{ kind: "directive", type: i6.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i6.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i6.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i6.NgSwitchDefault, selector: "[ngSwitchDefault]" }, { kind: "component", type: i3.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }, { kind: "component", type: i8.MatDivider, selector: "mat-divider", inputs: ["vertical", "inset"] }, { kind: "directive", type: i9.ButtonSizeDirective, selector: "[vzcButtonSize]", inputs: ["vzcButtonSize"] }, { kind: "component", type: i10.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i10.MatIconButton, selector: "button[mat-icon-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { kind: "component", type: i11.MatLegacyChipList, selector: "mat-chip-list", inputs: ["role", "aria-describedby", "errorStateMatcher", "multiple", "compareWith", "value", "required", "placeholder", "disabled", "aria-orientation", "selectable", "tabIndex"], outputs: ["change", "valueChange"], exportAs: ["matChipList"] }, { kind: "directive", type: i11.MatLegacyChip, selector: "mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]", inputs: ["color", "disableRipple", "tabIndex", "role", "selected", "value", "selectable", "disabled", "removable"], outputs: ["selectionChange", "destroyed", "removed"], exportAs: ["matChip"] }, { kind: "component", type: i12.MatLegacyProgressSpinner, selector: "mat-progress-spinner, mat-spinner", inputs: ["color", "diameter", "strokeWidth", "mode", "value"], exportAs: ["matProgressSpinner"] }, { kind: "component", type: InsightCardComponent, selector: "insights-panel-insight-card", inputs: ["insight"], outputs: ["openClicked"] }, { kind: "component", type: ThumbUpComponent, selector: "insights-panel-thumb-up" }, { kind: "component", type: ThumbUpSelectedComponent, selector: "insights-panel-thumb-up-selected" }, { kind: "component", type: ThumbDownComponent, selector: "insights-panel-thumb-down" }, { kind: "component", type: ThumbDownSelectedComponent, selector: "insights-panel-thumb-down-selected" }, { kind: "component", type: EmptyStateComponent, selector: "insights-panel-empty-state", inputs: ["title", "subtitle", "iconSvg", "showDefaultIcon"] }, { kind: "component", type: LearnMoreCardComponent, selector: "insights-panel-learn-more-card", outputs: ["learnMoreClicked"] }], changeDetection: i0.ChangeDetectionStrategy.Default }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.Default, selector: 'insights-panel', providers: [], template: "<div class=\"insights-panel\">\n  <div class=\"insights-panel__header\">\n    <div class=\"insights-panel__header__content\">\n      <span class=\"insights-panel__header__content__date\">{{ dateTitle }}</span>\n      <span class=\"insights-panel__header__content__title\">Insight highlights</span>\n    </div>\n    <div class=\"insights-panel__header__actions\">\n      <button\n        mat-icon-button\n        class=\"insights-panel__header__actions__close\"\n        tabindex=\"-1\"\n        vzcButtonSize=\"small\"\n        (click)=\"onCloseClicked()\"\n        data-automation-id=\"insights-panel_close-button\"\n        a7s-id=\"insights-panel_close-button\"\n      >\n        <mat-icon vzcIconSize=\"extraSmall\" svgIcon=\"ds-ic-close\"></mat-icon>\n      </button>\n    </div>\n  </div>\n\n  <mat-divider></mat-divider>\n\n  <div class=\"insights-panel__content\" [ngSwitch]=\"getContentState()\">\n    <div *ngSwitchCase=\"'loading'\" class=\"insights-panel__content__loading-state\">\n      <mat-spinner [diameter]=\"28\" color=\"accent\"></mat-spinner>\n    </div>\n\n    <ng-container *ngSwitchCase=\"'hasResults'\">\n      <insights-panel-learn-more-card *ngIf=\"learnMoreVisible\" (learnMoreClicked)=\"onLearnMoreClicked()\"></insights-panel-learn-more-card>\n\n      <insights-panel-insight-card\n        *ngFor=\"let insight of insightsResponse.results\"\n        [insight]=\"insight\"\n        (openClicked)=\"onInsightClicked($event)\"\n      ></insights-panel-insight-card>\n\n      <div class=\"insights-panel__content__feedback\">\n        <span class=\"insights-panel__content__feedback__text\"> Is this panel useful? </span>\n\n        <mat-chip-list class=\"insights-panel__content__feedback__chips\">\n          <mat-chip class=\"insights-panel__content__feedback__chips__chip\" a7s-id=\"insights-feedback-positive\" (click)=\"feedback(true)\">\n            <insights-panel-thumb-up class=\"icon\" *ngIf=\"!isPositiveFeedback\"></insights-panel-thumb-up>\n            <insights-panel-thumb-up-selected class=\"icon\" *ngIf=\"isPositiveFeedback\"></insights-panel-thumb-up-selected>\n          </mat-chip>\n          <mat-chip class=\"insights-panel__content__feedback__chips__chip\" a7s-id=\"insights-feedback-negative\" (click)=\"feedback(false)\">\n            <insights-panel-thumb-down class=\"icon\" *ngIf=\"!isNegativeFeedback\"></insights-panel-thumb-down>\n            <insights-panel-thumb-down-selected class=\"icon\" *ngIf=\"isNegativeFeedback\"></insights-panel-thumb-down-selected>\n          </mat-chip>\n        </mat-chip-list>\n      </div>\n    </ng-container>\n\n    <ng-container *ngSwitchDefault>\n      <insights-panel-learn-more-card *ngIf=\"learnMoreVisible\" (learnMoreClicked)=\"onLearnMoreClicked()\"></insights-panel-learn-more-card>\n      <insights-panel-empty-state title=\"No results\"></insights-panel-empty-state>\n    </ng-container>\n  </div>\n\n  <div class=\"insights-panel__footer\">\n    <div class=\"insights-panel__footer__actions\">\n      <button\n        class=\"insights-panel__footer__actions__button\"\n        mat-flat-button\n        color=\"accent\"\n        (click)=\"openInsights()\"\n        data-automation-id=\"insights-panel_open-insights-button\"\n        a7s-id=\"insights-panel_open-insights-button\"\n      >\n        GO TO INSIGHTS\n      </button>\n    </div>\n\n    <div class=\"insights-panel__footer__content\">\n      <span class=\"insights-panel__footer__content__text\">\n        This feature is an AI Beta release. Results may contain bugs, errors, or inaccuracies.\n      </span>\n    </div>\n  </div>\n</div>\n", styles: ["@charset \"UTF-8\";@import\"https://fonts.googleapis.com/icon?family=Material+Icons\";mat-icon{width:16px;height:16px;display:inline-flex!important;flex-shrink:0;justify-content:center}.pointer:hover{cursor:pointer;color:gray}h3{display:block;font-size:1.17em;font-weight:700!important}h4{font-size:.875rem;display:block;font-weight:700!important}.zendesk-link{cursor:pointer;color:#0088ce!important;text-decoration:none}.zendesk-link:hover{color:#005e8f!important;text-decoration:underline!important}.insights-panel{display:flex;flex-direction:column;height:100%}.insights-panel__header{flex-shrink:0;width:100%;border-bottom:1px solid #e0e0e0;padding:20px 24px 19px;display:flex;align-items:center;justify-content:space-between;z-index:10}.insights-panel__header__content{display:flex;flex-direction:column;gap:3px}.insights-panel__header__content__date{line-height:18px;font-size:12px;font-weight:400;color:#6f7171}.insights-panel__header__content__title{font-size:16px;font-weight:700;line-height:22px}.insights-panel__header__actions{margin-top:-24px}.insights-panel__content{flex:1 1 auto;overflow:auto;padding:16px;gap:16px;display:flex;flex-direction:column}.insights-panel__content__loading-state{display:flex;align-items:center;justify-content:center;gap:12px;padding:16px;color:#6f7171}.insights-panel__content__feedback{display:flex;flex-direction:row;justify-content:space-between;border-radius:38px;background:#f6f6f6;align-items:center;padding:0 16px;white-space:nowrap}.insights-panel__content__feedback__text{font-size:12px;line-height:18px;font-weight:400;vertical-align:middle}.insights-panel__content__feedback__chips{height:36px;padding-top:8px;margin-bottom:4px}.insights-panel__content__feedback__chips__chip{min-height:24px;background:transparent;color:transparent;padding:7px}.insights-panel__content__feedback__chips__chip .icon{height:20px}.insights-panel__content__feedback__chips__chip:hover{cursor:pointer}.insights-panel__footer{flex-shrink:0;width:100%;position:sticky;bottom:0;z-index:10}.insights-panel__footer__content{padding:0 16px 24px;display:flex;text-align:center;font-size:12px;flex-direction:column}.insights-panel__footer__content__text{color:#6f7171}.insights-panel__footer__content__link{text-decoration:underline}.insights-panel__footer__actions{padding:16px;border-top:1px solid #d8dada}.insights-panel__footer__actions__button{width:100%;font-weight:700}.mat-chip.mat-standard-chip.mat-chip-selected.mat-primary{background-color:transparent;color:transparent}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.Store }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [INSIGHTS_PANEL_CONFIG]
                }] }, { type: LocalStorageService }, { type: i3$1.PendoService }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: NavigationService }, { type: InsightsPanelService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { panelClosed: [{
                type: Output
            }] } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class InsightsPanelDrawerDirective {
    set userPreferences(value) {
        if (!this._initialized && !!value) {
            this._userPreferences = value;
            this.initialize();
        }
    }
    constructor(store, config, insightsPanelService, _breakpointObserver) {
        this.store = store;
        this.config = config;
        this.insightsPanelService = insightsPanelService;
        this._breakpointObserver = _breakpointObserver;
        this._sm = 600;
        this._md = 768;
        this._lg = 1024;
        this._xl = 1200;
        this._isSmallMobile = `(max-width: ${this._below(this._sm)}px)`;
        this._isMobile = `(max-width: ${this._below(this._md)}px)`;
        this._isTablet = `(min-width: ${this._md}px) and (max-width: ${this._below(this._lg)}px)`;
        this._isMobileOrTablet = `(max-width: ${this._below(this._lg)}px)`;
        this._isDesktop = `(min-width: ${this._lg}px)`;
        this._isSmallDesktop = `(min-width: ${this._lg}px) and (max-width: ${this._below(this._xl)}px)`;
        this._isLargeDesktop = `(min-width: ${this._xl}px)`;
        this._breakpoints = [
            this._isSmallMobile,
            this._isMobile,
            this._isTablet,
            this._isMobileOrTablet,
            this._isDesktop,
            this._isSmallDesktop,
            this._isLargeDesktop,
        ];
        this._initialized = false;
        this._isMobileOrTabletEnabled = false;
        this._unsubscribe$ = new Subject();
    }
    get drawerMode$() {
        return this.insightsPanelService.drawerMode$;
    }
    ngOnInit() {
        this.setupBreakpoints();
        this.isMobileOrTablet$.subscribe(isMobileOrTablet => {
            this._isMobileOrTabletEnabled = isMobileOrTablet;
            this.initialize();
        });
    }
    initialize() {
        const isEnabled = this.init();
        if (isEnabled && !this._isMobileOrTabletEnabled) {
            this.insightsPanelService.tryOpenDrawer();
        }
    }
    init() {
        if (this._initialized || !this._userPreferences) {
            return;
        }
        this._initialized = true;
        this.store.dispatch(new SetUserPreferences({ userPreferences: this._userPreferences }));
        if (!this.config.insightsPanel.enabled) {
            this.insightsPanelService.close();
            return false;
        }
        this.insightsPanelService.initialize(this._userPreferences);
        return true;
    }
    setupBreakpoints() {
        this._breakpoints$ = this._breakpointObserver.observe(this._breakpoints);
        const getBreakpointState = (breakpoint) => (src) => src.pipe(takeUntil(this._unsubscribe$), map(state => state.breakpoints[breakpoint]), shareReplay(1), distinctUntilChanged());
        this.isMobileOrTablet$ = this._breakpoints$.pipe(getBreakpointState(this._isMobileOrTablet));
    }
    _below(breakpoint) {
        return breakpoint - 0.02;
    }
    ngOnDestroy() {
        this._unsubscribe$.next();
        this._unsubscribe$.complete();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelDrawerDirective, deps: [{ token: i1$1.Store }, { token: INSIGHTS_PANEL_CONFIG }, { token: InsightsPanelService }, { token: i3$2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: InsightsPanelDrawerDirective, selector: "[insightsPanelDrawer]", inputs: { userPreferences: "userPreferences" }, exportAs: ["insightsPanelDrawer"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelDrawerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[insightsPanelDrawer]',
                    exportAs: 'insightsPanelDrawer',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.Store }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [INSIGHTS_PANEL_CONFIG]
                }] }, { type: InsightsPanelService }, { type: i3$2.BreakpointObserver }]; }, propDecorators: { userPreferences: [{
                type: Input
            }] } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Custom HttpParameterCodec
 * Workaround for https://github.com/angular/angular/issues/18261
 */
class CustomHttpParameterCodec {
    encodeKey(k) {
        return encodeURIComponent(k);
    }
    encodeValue(v) {
        return encodeURIComponent(v);
    }
    decodeKey(k) {
        return decodeURIComponent(k);
    }
    decodeValue(v) {
        return decodeURIComponent(v);
    }
}

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
class InsightsService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.encoder = new CustomHttpParameterCodec();
    }
    addToHttpParams(httpParams, value, key) {
        if (typeof value === 'object' && value instanceof Date === false) {
            httpParams = this.addToHttpParamsRecursive(httpParams, value);
        }
        else {
            httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
        }
        return httpParams;
    }
    addToHttpParamsRecursive(httpParams, value, key) {
        if (value == null) {
            return httpParams;
        }
        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                value.forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
            }
            else if (value instanceof Date) {
                if (key != null) {
                    httpParams = httpParams.append(key, value.toISOString().substr(0, 10));
                }
                else {
                    throw Error('key may not be null if value is Date');
                }
            }
            else {
                Object.keys(value).forEach(k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k)));
            }
        }
        else if (key != null) {
            httpParams = httpParams.append(key, value);
        }
        else {
            throw Error('key may not be null if value is not object or array');
        }
        return httpParams;
    }
    getInsights(fromDate, toDate, pageSize, isRead, categoryIds, subCategoryIds, nextPageToken) {
        if (fromDate === null || fromDate === undefined) {
            throw new Error('Required parameter fromDate was null or undefined when calling getInsights.');
        }
        if (toDate === null || toDate === undefined) {
            throw new Error('Required parameter toDate was null or undefined when calling getInsights.');
        }
        let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
        if (fromDate !== undefined && fromDate !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, fromDate, 'FromDate');
        }
        if (toDate !== undefined && toDate !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, toDate, 'ToDate');
        }
        if (pageSize !== undefined && pageSize !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, pageSize, 'PageSize');
        }
        if (isRead !== undefined && isRead !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, isRead, 'IsRead');
        }
        if (categoryIds !== undefined && categoryIds !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, categoryIds, 'CategoryIds');
        }
        if (subCategoryIds !== undefined && subCategoryIds !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, subCategoryIds, 'SubCategoryIds');
        }
        if (nextPageToken !== undefined && nextPageToken !== null) {
            localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, nextPageToken, 'nextPageToken');
        }
        return this.http.get(`${this.config.insightsPanel.insightsApi}/v1/insights`, {
            params: localVarQueryParameters,
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsService, deps: [{ token: i1$2.HttpClient }, { token: INSIGHTS_PANEL_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [INSIGHTS_PANEL_CONFIG]
                }] }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
const routes = [
    {
        path: INSIGHT_PANEL_OUTLET,
        component: InsightsPanelComponent,
        outlet: SIDE_DRAWER_OUTLET,
    },
];
class InsightsPanelRoutingModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelRoutingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelRoutingModule, imports: [i1.RouterModule], exports: [RouterModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelRoutingModule, imports: [RouterModule.forChild(routes), RouterModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelRoutingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [RouterModule.forChild(routes)],
                    exports: [RouterModule],
                }]
        }] });

/*
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
class FeaturesService {
    constructor(http, config) {
        this.http = http;
        this.config = config;
        this.encoder = new CustomHttpParameterCodec();
    }
    encodeParam(param) {
        // This implementation exists as fallback for missing configuration
        // and for backwards compatibility to older typescript-angular generator versions.
        // It only works for the 'simple' parameter style.
        // Date-handling only works for the 'date-time' format.
        // All other styles and Date-formats are probably handled incorrectly.
        //
        // But: if that's all you need (i.e.: the most common use-case): no need for customization!
        const value = param.dataFormat === 'date-time' && param.value instanceof Date ? param.value.toISOString() : param.value;
        return encodeURIComponent(String(value));
    }
    v1FeaturesPermissionIdStatusGet(permissionId) {
        if (permissionId === null || permissionId === undefined) {
            throw new Error('Required parameter permissionId was null or undefined when calling v1FeaturesPermissionIdStatusGet.');
        }
        const localVarPath = `/v1/Features/${this.encodeParam({ name: 'permissionId', value: permissionId, in: 'path', style: 'simple', explode: false, dataType: 'number', dataFormat: 'int32' })}/status`;
        return this.http.get(`${this.config.insightsPanel.insightsApi}${localVarPath}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeaturesService, deps: [{ token: i1$2.HttpClient }, { token: INSIGHTS_PANEL_CONFIG }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeaturesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FeaturesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [INSIGHTS_PANEL_CONFIG]
                }] }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-unused-vars */
const OPERATIONAL_INSIGHTS_PERMISSION_ID = 298;
class InsightsPanelEffects {
    constructor(actions$, insightsService, featuresService, store) {
        this.actions$ = actions$;
        this.insightsService = insightsService;
        this.featuresService = featuresService;
        this.store = store;
        this.getInsights$ = createEffect(() => this.actions$.pipe(ofType(InsightsPanelActionTypes.GetInsightsAction), withLatestFrom(this.store.pipe(select(selectDateRange)), this.store.pipe(select(selectHasAccess))), switchMap(([action, dateRange, hasAccess]) => {
            if (hasAccess === true) {
                // Only call insightsService if hasAccess is true
                return this.getInsightsHandler(dateRange);
            }
            else if (hasAccess === undefined) {
                // Dispatch permission check, then wait for permission to resolve, then call insightsService
                this.store.dispatch(new CheckUserHasMicrositePermission());
                return this.actions$.pipe(ofType(InsightsPanelActionTypes.CheckUserHasMicrositePermissionSuccessAction), withLatestFrom(this.store.pipe(select(selectHasAccess))), switchMap(([_, resolvedAccess]) => {
                    if (resolvedAccess) {
                        return this.getInsightsHandler(dateRange);
                    }
                    else {
                        return of(new GetInsightsSuccess({ response: { results: [], count: 0, hasNextPage: false } }));
                    }
                }));
            }
            else {
                // If hasAccess is false, do nothing
                return of(new GetInsightsSuccess({ response: { results: [], count: 0, hasNextPage: false } }));
            }
        })));
        this.checkUserMicrositePermission$ = createEffect(() => this.actions$.pipe(ofType(InsightsPanelActionTypes.CheckUserHasMicrositePermissionAction), switchMap((action) => this.featuresService.v1FeaturesPermissionIdStatusGet(OPERATIONAL_INSIGHTS_PERMISSION_ID).pipe(map(hasAccess => new CheckUserHasMicrositePermissionSuccess({ hasAccess })), catchError(error => of(new CheckUserHasMicrositePermissionFailure({ error: error.message || 'Unknown error' })))))));
    }
    getInsightsHandler(dateRange) {
        return this.insightsService
            .getInsights(dateRange?.fromDate?.toISOString().slice(0, 10), dateRange?.toDate?.toISOString().slice(0, 10), 4)
            .pipe(map(response => new GetInsightsSuccess({ response })), catchError(error => of(new GetInsightsFailure({ error: error.message || 'Unknown error' }))));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelEffects, deps: [{ token: i1$3.Actions }, { token: InsightsService }, { token: FeaturesService }, { token: i1$1.Store }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelEffects }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelEffects, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1$3.Actions }, { type: InsightsService }, { type: FeaturesService }, { type: i1$1.Store }]; } });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
const initialInsightsPanelState = {
    dateRange: undefined,
    response: undefined,
    loading: LoadingState._,
    error: undefined,
    hasAccess: undefined,
    userPreferences: undefined,
};

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
function insightsPanelReducer(state = initialInsightsPanelState, action) {
    switch (action.type) {
        case InsightsPanelActionTypes.GetInsightsAction:
            return {
                ...state,
                dateRange: {
                    fromDate: action.payload.fromDate,
                    toDate: action.payload.toDate,
                },
                loading: LoadingState.LOADING,
                error: null,
            };
        case InsightsPanelActionTypes.GetInsightsSuccessAction:
            return {
                ...state,
                response: action.payload.response,
                loading: LoadingState.LOADED,
                error: null,
            };
        case InsightsPanelActionTypes.GetInsightsFailureAction:
            return {
                ...state,
                loading: LoadingState.ERROR,
                error: action.payload.error,
            };
        case InsightsPanelActionTypes.CheckUserHasMicrositePermissionAction:
            return {
                ...state,
                error: null,
            };
        case InsightsPanelActionTypes.CheckUserHasMicrositePermissionSuccessAction:
            return {
                ...state,
                hasAccess: action.payload.hasAccess,
                error: null,
            };
        case InsightsPanelActionTypes.CheckUserHasMicrositePermissionErrorAction:
            return {
                ...state,
                error: action.payload.error,
            };
        case InsightsPanelActionTypes.SetUserPreferencesAction:
            return {
                ...state,
                userPreferences: action.payload.userPreferences,
            };
        default:
            return state;
    }
}

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */
class InsightsPanelModule {
    static forRoot(configs) {
        return {
            ngModule: InsightsPanelModule,
            providers: [
                {
                    provide: INSIGHTS_PANEL_CONFIG,
                    useValue: configs,
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelModule, declarations: [InsightsPanelComponent,
            InsightsPanelDrawerDirective,
            InsightCardComponent,
            ThumbUpComponent,
            ThumbUpSelectedComponent,
            ThumbDownComponent,
            ThumbDownSelectedComponent,
            PeriodDateFormatterPipe,
            EmptyStateComponent,
            LearnMoreCardComponent], imports: [CommonModule,
            InsightsPanelRoutingModule,
            HttpClientModule,
            MatCardModule,
            MatIconModule,
            MatInputModule,
            MatDividerModule,
            ButtonSizeModule,
            MatButtonModule,
            ChipTagModule,
            MatLegacyChipsModule,
            MatLegacyProgressSpinnerModule, i1$1.StoreFeatureModule, i1$3.EffectsFeatureModule], exports: [InsightsPanelComponent, InsightsPanelDrawerDirective, PeriodDateFormatterPipe, EmptyStateComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelModule, providers: [InsightsService, LocalStorageService], imports: [CommonModule,
            InsightsPanelRoutingModule,
            HttpClientModule,
            MatCardModule,
            MatIconModule,
            MatInputModule,
            MatDividerModule,
            ButtonSizeModule,
            MatButtonModule,
            ChipTagModule,
            MatLegacyChipsModule,
            MatLegacyProgressSpinnerModule,
            StoreModule.forFeature('insightsPanel', insightsPanelReducer),
            EffectsModule.forFeature([InsightsPanelEffects])] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: InsightsPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        InsightsPanelComponent,
                        InsightsPanelDrawerDirective,
                        InsightCardComponent,
                        ThumbUpComponent,
                        ThumbUpSelectedComponent,
                        ThumbDownComponent,
                        ThumbDownSelectedComponent,
                        PeriodDateFormatterPipe,
                        EmptyStateComponent,
                        LearnMoreCardComponent,
                    ],
                    imports: [
                        CommonModule,
                        InsightsPanelRoutingModule,
                        HttpClientModule,
                        MatCardModule,
                        MatIconModule,
                        MatInputModule,
                        MatDividerModule,
                        ButtonSizeModule,
                        MatButtonModule,
                        ChipTagModule,
                        MatLegacyChipsModule,
                        MatLegacyProgressSpinnerModule,
                        StoreModule.forFeature('insightsPanel', insightsPanelReducer),
                        EffectsModule.forFeature([InsightsPanelEffects]),
                    ],
                    exports: [InsightsPanelComponent, InsightsPanelDrawerDirective, PeriodDateFormatterPipe, EmptyStateComponent],
                    providers: [InsightsService, LocalStorageService],
                }]
        }] });

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EmptyStateComponent, INSIGHTS_PANEL_CONFIG, INSIGHT_PANEL_OUTLET, InsightsPanelComponent, InsightsPanelDrawerDirective, InsightsPanelModule, InsightsPanelRoutingModule, InsightsPanelService, PeriodDateFormatterPipe };
